import { coerceValueRef } from "../authContext";
import type { AuthDescriptor, ValueRefInput } from "../authDescriptor";

export function bearerAuth(token: ValueRefInput): AuthDescriptor {
  return { type: "bearer", token: coerceValueRef(token) };
}
